import { hyperdbTriggers } from 'hyperdb-utils';
import * as config from '../../../../config';

export default hyperdbTriggers({ config,
  triggerName: 'propertyGroup',
  namespace: 'PROPERTY_GROUP',
  entryPoint: '/propertyGroups',
  collectionName: 'property_groups',
  querySearchListing: [
    ['name', 'description'],
    { order: { id: 'asc' } }
  ],
  quickSearch: (keyword) => ({ $any: [{ name: { match: keyword } }] }),
  successMessageCreate: 'Group created',
  successMessageUpdate: 'Group updated',
  successMessageDelete: 'Group deleted',
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/propertyGroup/triggers.js